import { render, staticRenderFns } from "./advancement-info-panel.vue?vue&type=template&id=ca6b4d30&scoped=true&"
import script from "./advancement-info-panel.vue?vue&type=script&lang=js&"
export * from "./advancement-info-panel.vue?vue&type=script&lang=js&"
import style0 from "./advancement-info-panel.vue?vue&type=style&index=0&id=ca6b4d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6b4d30",
  null
  
)

export default component.exports